import {
  useState,
  ChangeEvent,
  forwardRef,
  KeyboardEvent,
  useEffect,
} from 'react';
import classnames from 'classnames';

import styles from './Input.module.css';

type InputProps = {
  placeholder: string;
  className?: string;
  onChange?: (value: string) => void;
  onSave?: (value: string) => void;
  cleanAfterSave?: boolean;
  clear?: boolean;
};

export default forwardRef<HTMLInputElement, InputProps>(function Input(
  props,
  ref,
) {
  const { placeholder, className, onChange, onSave, cleanAfterSave, clear } =
    props;
  const [value, setValue] = useState('');
  const [raisePlaceholder, setRaisePlaceholder] = useState(false);

  const onInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    setValue(inputValue);
    if (onChange) onChange(inputValue);
  };

  const onInputFocus = () => {
    setRaisePlaceholder(true);
  };

  const onInputBlur = () => {
    if (!value) setRaisePlaceholder(false);
  };

  const onInputKeyUp = (e: KeyboardEvent) => {
    if (e.key === 'Enter' && onSave) {
      if (cleanAfterSave) setValue('');
      onSave(value);
    }
  };

  useEffect(() => {
    if (clear) {
      setValue('');
      setRaisePlaceholder(false);
    }
  }, [clear]);

  return (
    <div className={classnames(styles.input, className)}>
      <div
        className={classnames(styles.tip, {
          [styles.isPlaceholder]: !raisePlaceholder,
          'tw-text-xs': raisePlaceholder,
        })}
      >
        <p
          className={classnames('leading-none', {
            'tw-text-gray-500': raisePlaceholder,
            'tw-text-gray-400': !raisePlaceholder,
          })}
        >
          {placeholder}
        </p>
      </div>
      <input
        className={styles.inputElem}
        ref={ref}
        onChange={onInputChange}
        onFocus={onInputFocus}
        onBlur={onInputBlur}
        onKeyUp={onInputKeyUp}
        value={value}
      />
    </div>
  );
});
